<nz-page-header *ngIf="!ticket" nzTitle="Loading Ticket"></nz-page-header>
<ng-container *ngIf="ticket">
	<nz-page-header *ngIf="!ticket.id" nzTitle="Create Ticket"></nz-page-header>
	<nz-page-header *ngIf="ticket.id" nzTitle="Manage Ticket"></nz-page-header>

	<nz-steps nzDirection="horizontal" nzLabelPlacement="vertical" (nzIndexChange)="selectedStepIndex=$event" [nzCurrent]="selectedStepIndex">
		<nz-step *ngFor="let step of ticket.steps" [nzTitle]="step.label" [nzSubtitle]="step.description" [nzStatus]="getStepStatus(step)" [nzDisabled]="!step.isCurrentState"></nz-step>
	</nz-steps>
</ng-container>



<nz-alert
	*ngIf="ticket && !ticket.hasAccess"
	nzType="warning"
	nzMessage="Read Only"
	nzDescription="You don't have permissions to process this ticket."
	nzShowIcon
	class="mb-3">
</nz-alert>

<div *ngIf="ticket">
	<nz-card nzTitle="Details" [nzExtra]="extraTmpl">
		<div class="row"  *ngIf="step.details.length == 0">
			<div class="col">
				<nz-empty nzNotFoundContent="No details to show"></nz-empty>
			</div>
		</div>

		<div class="row"  *ngIf="step.details.length > 0">
			<div class="col">
				<div *ngFor="let group of getDetailGroups(step);let i=index">
					<h5 [ngClass]="{'mt-4':i>0}">
						{{group.groupLabel}}
					</h5>
					<div class="row">
						<div class="col-3" *ngFor="let detail of group.details">
							<nz-form-item>
								<nz-form-control>
									<nz-form-label>{{ detail.label }}</nz-form-label>
									<nz-form-control>
										<input nz-input [placeholder]="detail.label" [value]="detail.value" readonly/>
									</nz-form-control>
								</nz-form-control>
							</nz-form-item>
						</div>
					</div>
				</div>
			</div>
		</div>
		<ng-template #extraTmpl>
			<button *ngIf="ticket.relatedToOtherTicket" nz-button (click)="showTicketHistory(ticket.relatedToOtherTicket,'Reported Ticket History')">View Reported Ticket Details</button>
			<button *ngIf="ticket.id" nz-button (click)="showTicketHistory(ticket,'Tickets History')">Tickets History</button>
		</ng-template>
	</nz-card>

	<ng-container *ngIf="!step.isCurrentState">
		<app-dft-card *ngFor="let section of step.sections"
			[title]="section.label"
			[readonly]="true"
			[dynamicForm]="dynamicForms![section.id]">
		</app-dft-card>
		<app-ticket-form-section-images [ticket]="ticket" [step]="step"></app-ticket-form-section-images>
	</ng-container>

	<ng-container *ngIf="step.isCurrentState">
		<app-dft-card *ngFor="let section of step.sections"
			[title]="section.label"
			[readonly]="!ticket.hasAccess || !step.isCurrentState"
			[dynamicForm]="dynamicForms![section.id]"
			[allFormControls]="allFormControls"
			[allForms]="allForms"
			[masterForm]="masterForm">
		</app-dft-card>
		<app-ticket-form-section-images
			[ticket]="ticket"
			[step]="step"
			[formControls]="allFormControls"
			[additionalFileFormGroup]="additionalFilesForm"
			[readonly]="!ticket.hasAccess || !step.isCurrentState">
		</app-ticket-form-section-images>
		<div class="row mt-4" *ngIf="ticket.hasAccess">
			<div class="col">
				<ng-container *ngFor="let button of step.buttons">
					<ng-container *ngIf="button.requiredValidForm == false || masterForm.valid == true">
						<button *ngIf="button.style == 'Default'" nz-button nzSize="large" [nzType]="getNzButtonType(button)" (click)="buttonClick(button)" class="me-2" [ngClass]="{'float-start': button.alignment == 'Left', 'float-end': button.alignment == 'Right'}">
							<fa-icon class="me-2" *ngIf="button.icon" [icon]="['fas', button.icon]"></fa-icon>
							{{button.label}}
						</button>
						<button *ngIf="button.style == 'Danger'" nz-button nzSize="large" [nzType]="getNzButtonType(button)" (click)="buttonClick(button)" class="me-2" [ngClass]="{'float-start': button.alignment == 'Left', 'float-end': button.alignment == 'Right'}">
							<fa-icon class="me-2" *ngIf="button.icon" [icon]="['fas', button.icon]"></fa-icon>
							{{button.label}}
						</button>
						<button *ngIf="button.style == 'Ghost'" nz-button nzSize="large" [nzType]="getNzButtonType(button)" (click)="buttonClick(button)" class="me-2" [ngClass]="{'float-start': button.alignment == 'Left', 'float-end': button.alignment == 'Right'}">
							<fa-icon class="me-2" *ngIf="button.icon" [icon]="['fas', button.icon]"></fa-icon>
							{{button.label}}
						</button>
					</ng-container>
					<ng-container *ngIf="button.requiredValidForm == true && masterForm.valid == false">
						<button *ngIf="button.style == 'Default'" nz-button nzSize="large" [nzType]="getNzButtonType(button)" (click)="highlightInvalidFields()" class="me-2" [ngClass]="{'float-start': button.alignment == 'Left', 'float-end': button.alignment == 'Right'}">
							<nz-icon [nzType]="'warning'" nzTheme="twotone" nzTwotoneColor="#eb2f96"/>
							{{button.label}}
						</button>
						<button *ngIf="button.style == 'Danger'" nz-button nzSize="large" [nzType]="getNzButtonType(button)" (click)="highlightInvalidFields()" class="me-2" [ngClass]="{'float-start': button.alignment == 'Left', 'float-end': button.alignment == 'Right'}">
							<nz-icon [nzType]="'warning'" nzTheme="twotone" nzTwotoneColor="#eb2f96"/>
							{{button.label}}
						</button>
						<button *ngIf="button.style == 'Ghost'" nz-button nzSize="large" [nzType]="getNzButtonType(button)" (click)="highlightInvalidFields()" class="me-2" [ngClass]="{'float-start': button.alignment == 'Left', 'float-end': button.alignment == 'Right'}">
							<nz-icon [nzType]="'warning'" nzTheme="twotone" nzTwotoneColor="#eb2f96"/>
							{{button.label}}
						</button>
					</ng-container>
				</ng-container>
			</div>
		</div>
	</ng-container>
</div>
